import { environment } from "../../../environment";
export const tasksUrl = (version) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/task/${version}/tasks`
    : `https://middleware.uat.farther.com/task/${version}/tasks`;
export const taskUrl = (version, taskId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/task/${version}/tasks/${taskId}`
    : `https://middleware.uat.farther.com/task/${version}/tasks/${taskId}`;
export const clientsUrl = (version) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/task/${version}/persons/clients`
    : `https://middleware.uat.farther.com/task/${version}/persons/clients`;
export const advisorsUrl = (version) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/task/${version}/persons/advisors`
    : `https://middleware.uat.farther.com/task/${version}/persons/advisors`;
export const assigneesUrl = (version) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/task/${version}/persons/assignees`
    : `https://middleware.uat.farther.com/task/${version}/persons/assignees`;
export const taskCommentsUrl = (taskId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/task/v1/tasks/${taskId}/comments`
    : `https://middleware.uat.farther.com/task/v1/tasks/${taskId}/comments`;
export const taskCommentUrl = (taskId, commentId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/task/v1/tasks/${taskId}/comments/${commentId}`
    : `https://middleware.uat.farther.com/task/v1/tasks/${taskId}/comments/${commentId}`;
export const attachmentUrl = (attachmentId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/task/v1/attachments/${attachmentId}`
    : `https://middleware.uat.farther.com/task/v1/attachments/${attachmentId}`;
export const taskActivityUrl = (taskId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/activity/Task/${taskId}`
    : `https://middleware.uat.farther.com/activity/Task/${taskId}`;
//# sourceMappingURL=urls.js.map